import PropTypes from 'prop-types';
import React, { Component, createElement } from 'react';
import { change } from 'redux-form';
import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { InlineEditorActions } from '../../actions/inlineEditor';
import InlineEditorForm from './InlineEditorForm';
// import _ from 'lodash';

const InlineFormValueSelector = (state, props) => {
  return Immutable.Iterable.isIterable(props.value)
    ? props.value.toJS()
    : props.value;
};

const isEditingSelector = (state, props) =>
  state.inlineEditors.getIn(['editors', props.form], null);

const inlineSelector = createSelector(
  [isEditingSelector, InlineFormValueSelector],
  (editing, inlineForm) => ({
    editing,
    initialValues: {
      field: inlineForm,
    },
  }),
);

@connect(inlineSelector)
export default class InlineEditor extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    value: PropTypes.any,
    form: PropTypes.string,
    component: PropTypes.any,
    editing: PropTypes.bool,
    onSave: PropTypes.func,
    propertyKey: PropTypes.string,
    metaKey: PropTypes.string,
    handleSubmit: PropTypes.func,
    reset: PropTypes.func,
    showHelpText: PropTypes.bool,
    customHelpText: PropTypes.string,
    disableKeyDown: PropTypes.bool,
    meta: PropTypes.object,
    currentElementId: PropTypes.string,
    customMeta: PropTypes.bool,
    fieldIndex: PropTypes.number,
    inlineTypeOptions: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.bool,
      PropTypes.object,
    ]),
  };

  toggleInlineEdit = (setValue = true) => {
    const { dispatch, form, editing, value } = this.props;
    dispatch(InlineEditorActions.setInlineEditState(form, !editing));
    if (setValue) {
      const jsVal = Immutable.Iterable.isIterable(value) ? value.toJS() : value;
      dispatch(change(form, 'field', jsVal));
    }
  };

  render = () => {
    const {
      component,
      // value,
      // form,
      // onSave,
      editing,
      // handleSubmit,
      // showHelpText,
      // customHelpText,
      // disableKeyDown,
      // meta,
      inlineTypeOptions,
      // currentElementId,
      // fieldIndex,
    } = this.props;

    const typeOptions = inlineTypeOptions || null;

    if (editing) {
      return (
        <InlineEditorForm
          {...this.props}
          typeOptions={typeOptions}
          toggleEditor={this.toggleInlineEdit}
        />
      );
    }
    return createElement(component.display, {
      ...this.props,
      typeOptions,
      toggleEditor: this.toggleInlineEdit,
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/types/InlineEditor.js